const setStoreCode = (state, storeCode) => {
  state.commit("SET_STORE_CODE", storeCode);
  if(storeCode == 'zeborne') {
    state.commit("SET_PAYPAL_METHOD_NAME", '12.PayPal.standard');
  }
  else {
    state.commit("SET_PAYPAL_METHOD_NAME", '9.PayPal.standard');
  }
};

export default {
  setStoreCode
};
